import { Component, Input, OnInit, NgModule } from '@angular/core';

import { PageTitleService } from './../../../../services/ui/page-title.service';

@Component({
    selector: 'cmn-page-title',
    templateUrl: 'cmn-page-title.component.html',
    standalone: false
})

export class CmnPageTitleComponent implements OnInit {
    pageTitle: string = "";
    constructor(public pageTitleService: PageTitleService) {
        
    }
    
    ngOnInit() {
         
    }
}